import { render, staticRenderFns } from "./InventoryForm.vue?vue&type=template&id=2c379c80&scoped=true&"
import script from "./InventoryForm.vue?vue&type=script&lang=ts&"
export * from "./InventoryForm.vue?vue&type=script&lang=ts&"
import style0 from "./InventoryForm.vue?vue&type=style&index=0&id=2c379c80&lang=scss&scoped=true&"
import style1 from "./InventoryForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c379c80",
  null
  
)

export default component.exports